import { Button, Checkbox, Modal } from "antd";
import { Image } from "antd";
import "./ConfirmModal.scss";
import Coin from "@assets/img/Coinbg.png";
import { MoneyCollectFilled } from "@ant-design/icons";

interface IConfirmModal {
  isOpen: boolean;
  closeModal: () => void;
  handleCreateCampaign: () => void;
}

const ConfirmModal: React.FC<IConfirmModal> = ({
  isOpen,
  closeModal,
  handleCreateCampaign,
}) => {
  return (
    <Modal
      className="ConfirmModal"
      open={isOpen}
      onCancel={closeModal}
      footer={false}
    >
      <div className="container confirm-container">
        <div className="confirm-logo">
          <Image src={Coin}/>
        </div>
        <div className="confirm-title">Confirm Payment</div>
        <div className="confirm-coin-remain">
          Coin remained: 50 <MoneyCollectFilled color="yellow" />
        </div>
        <div className="confirm-coin-charge">
          30 HeppCoin will be charge for this campaign
        </div>
        <div className="confirm-notice">This action can not be undone</div>
        <div className="confirm-dont-show">
          <Checkbox onChange={() => console.log(1)}>Don't show agian</Checkbox>
        </div>
        <Button className="confirm-btn" onClick={handleCreateCampaign}>
          Confirm
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
